module.exports = __webpack_public_path__ + "assets/img/36_509.07095a42.jpg";